import { render, staticRenderFns } from "./modify-user.vue?vue&type=template&id=1885151e&scoped=true"
import script from "./modify-user.vue?vue&type=script&lang=ts"
export * from "./modify-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885151e",
  null
  
)

export default component.exports